module.exports = __webpack_public_path__ + "assets/d5072ffc754a81706a6c14bc5027686d.png";